<div class="card">
  <div class="card-header">
    <h3 class="card-title">
      <i class="fa fa-bar-chart-o"></i>
      {{ 'checkout' | translate }} {{ checkout().name }}
    </h3>
    <div class="card-tools float-right">
      <form-row-select
        [icon]="null"
        [model]="selectedTimespan()"
        [options]="timespans"
        (modelChange)="setTimespan($event)"
      ></form-row-select>
    </div>
  </div>
  @if (!isNoDataForChart()) {
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-lg-6">
          <app-chart
            [type]="'carrierUsage'"
            [chartData]="queryCarrierUsageData.data() ?? []"
            [isPending]="queryCarrierUsageData.isPending()"
          ></app-chart>
        </div>
        <div class="col-12 col-lg-6">
          <app-chart
            [type]="'paymentSales'"
            [chartData]="queryPaymentSalesData.data() ?? []"
            [isPending]="queryPaymentSalesData.isPending()"
          ></app-chart>
        </div>
        <div class="col-12">
          <app-chart
            [type]="'bestsellers'"
            [chartData]="queryBestsellersData.data() ?? []"
            [isPending]="queryBestsellersData.isPending()"
          ></app-chart>
        </div>
      </div>
    </div>
  }
  @if (isNoDataForChart()) {
    <div class="card-body">
      {{ 'chart.noDataForTimespan' | translate }}
    </div>
  }
</div>
